import type { Address } from 'viem';

/** Trim and strip optional quotes from .env values. */
function addr(v: string | undefined): Address | undefined {
  if (!v) return undefined;
  const t = v.trim().replace(/^['"]|['"]$/g, '');
  if (!t.startsWith('0x') || t.length !== 42) return undefined;
  return t as Address;
}

/** Set per-chain factory addresses after deployment. */
export const factoryByChainId: Record<number, Address | undefined> = {
  1: addr(process.env.REACT_APP_FACTORY_ETHEREUM),
  10: addr(process.env.REACT_APP_FACTORY_OPTIMISM),
  56: addr(process.env.REACT_APP_FACTORY_BSC),
  100: addr(process.env.REACT_APP_FACTORY_GNOSIS),
  130: addr(process.env.REACT_APP_FACTORY_UNICHAIN),
  137: addr(process.env.REACT_APP_FACTORY_POLYGON),
  143: addr(process.env.REACT_APP_FACTORY_MONAD),
  1514: addr(process.env.REACT_APP_FACTORY_STORY),
  2741: addr(process.env.REACT_APP_FACTORY_ABSTRACT),
  5000: addr(process.env.REACT_APP_FACTORY_MANTLE),
  42161: addr(process.env.REACT_APP_FACTORY_ARBITRUM),
  43114: addr(process.env.REACT_APP_FACTORY_AVALANCHE),
  59144: addr(process.env.REACT_APP_FACTORY_LINEA),
  534352: addr(process.env.REACT_APP_FACTORY_SCROLL),
  8453: addr(process.env.REACT_APP_FACTORY_BASE),
  369: addr(process.env.REACT_APP_FACTORY_PULSECHAIN),
  11155111: addr(process.env.REACT_APP_FACTORY_SEPOLIA),
};

export function getFactoryAddress(chainId: number | undefined): Address | undefined {
  if (chainId === undefined) return undefined;
  return factoryByChainId[chainId];
}
